import axios from 'axios';
import apiConfig from '../shared/config/api.config';

let cancelTokenSource;

function cancelPreviousLiteralsRequest() {
  if (cancelTokenSource) {
    cancelTokenSource.cancel('Request canceled');
  }
}

export default function literalsRequest(language) {
  cancelPreviousLiteralsRequest();
  cancelTokenSource = axios.CancelToken.source();

  const {
    host,
    URIs: { literals },
  } = apiConfig;

  const uri = `${host}${literals}?${new Date().getTime()}`.replace(':language', language);

  return axios
    .get(uri, { cancelToken: cancelTokenSource.token })
    .then(res => {
      return res.data;
    })
    .catch(error => {
      if (!axios.isCancel(error)) {
        throw error;
      }
    });
}
